import React from "react";
import { useState, useEffect } from "react";

const Misson = () => {

    const [data, setData] = useState("");

    useEffect(() => {
        const url = "https://sbvmapi.uniservedata.in/api/content?nameType=Mission for Achievement";
        GetData(url);
    }, []);

    const GetData = async (url) => {
        const data = await fetch(url);
        const res = await data.json();
        //console.log(res.content_data);  
        setData(res.content_data[0].textData);
    }


    return (


        <div className="about_section layout_padding " style={{ "backgroundColor": "rgb(231 208 180 / 30%)" }}>

            <div className="container">
                <div className="row d-flex align-items-center justify-content-center vh-100">
                    <div className="col-md-8 text-center">
                        <h1 className="news_taital" style={{ display: 'inline-block', position: 'relative' }}>
                            Mission Of Achievement
                            <hr
                                style={{
                                    height: '3px',
                                    backgroundColor: 'currentColor',
                                    width: '59%',
                                    margin: '14px auto 17px',
                                    border: 'none',
                                }}
                            />
                        </h1>
                    </div>
                </div>


                <div className="row">
                    <div className="col-lg-6 col-md-6 d-flex align-items-center equal-height">
                        <p
                            className="m-0"
                            dangerouslySetInnerHTML={{ __html: data }}
                            style={{ overflowY: 'auto' }}
                        ></p>
                    </div>
                    <div className="col-lg-6 col-md-6 ">
                        <iframe
                            loading="lazy"
                            src="https://www.youtube.com/embed/hbfnmtfXJzo"
                            frameBorder="0"
                            allowFullScreen
                            className="video1 equal-height"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>


        /* </div> */
    );
}
export default Misson;